import { FetchError } from 'ofetch'

export const getValidErrorMessage = (error: MaybeRef<FetchError<any> | null>, customMessage?: string) => {
    if (unref(error)?.data?.message && Array.isArray(unref(error)?.data?.message)) {
        return unref(error)?.data?.message?.join('\n')
    } else if (unref(error)?.data?.message) {
        return JSON.stringify(unref(error)?.data?.message)
    } else if (customMessage) {
        return customMessage
    } else {
        return unref(error)?.message ?? 'Ошибка'
    }
}
